import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const AptevoChargebacksSourceMapmonthly = () => {
    const fileName = 'Aptevo Chargebacks Source ';
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const [aptevoChargeBacks, setAptevoChargeBacks] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    // excel Headers
    const excelColumns = [
        
        {
            Header: "Debit Memo #",
            accessor: "DebitMemoNum",
            filter: "DebitMemoNum",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Invoice Number",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
            width:130,
        },
        {
            Header: "Member Name",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
            width:125,
        }, {
            Header: "Member Address- number,street,city,state,zip",
            accessor: "MemberAddress",
            filter: "MemberAddress",
            sortType: "basic",
            width:250,
        }, {
            Header: "Member ID- HIN or DEA",
            accessor: "MemberIDHIN",
            filter: "MemberIDHIN",
            sortType: "basic",
            width:180,
        },
        {
            Header: "Contract Number",
            accessor: "ContractNumber",
            filter: "ContractNumber",
            sortType: "basic",
            width:150,
        },
        {
            Header: "Invoice Date",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            width:120,
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "NDC",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Quantity Sold",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Units/Vial",
            accessor: "DosageORUnits",
            filter: "DosageORUnits",
            sortType: "basic",
            width:100,
        },
        {
            Header: "DAC Price",
            accessor: "DACperIUOREUORGram",
            filter: "DACperIUOREUORGram",
            sortType: "basic",
            width:100,
        },
        {
            Header: "Contract Price",
            accessor: "ContractpriceperIUOREUORGram",
            filter: "ContractpriceperIUOREUORGram",
            sortType: "basic",
            width:120,
        },
        {
            Header: "Total Chargeback Amount",
            accessor: "ChargebackAmount",
            filter: "ChargebackAmount",
            sortType: "basic",
            width:150,
        },
        {
            Header: "Total IU",
            accessor: "TotalIU",
            filter: "TotalIU",
            sortType: "basic",
            width:100,
        },    
    ];

    useEffect(() => {
        getAptevoChargeBacks();
    }, [])
    async function getAptevoChargeBacks() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=ChargebacksMonthly&TaskTypeCode=AptevoChargebacks`;
        await _HttpServices
            .getData(url)
            .then((data) => {
                const aptevoChargeBacks = data.data;
                if(aptevoChargeBacks.length > 0){
                    aptevoChargeBacks.map((res) => {                        
                        res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');
                        res.ContractpriceperIUOREUORGram = res.ContractpriceperIUOREUORGram == null? "0.00" : (res.ContractpriceperIUOREUORGram*1).toFixed(2);
                        res.DACperIUOREUORGram = res.DACperIUOREUORGram == null? "0.00" : (res.DACperIUOREUORGram*1).toFixed(2);
                        res.ChargebackAmount ="$" + (res.ChargebackAmount * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    })
                  }
                setAptevoChargeBacks(aptevoChargeBacks);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });
    }
    const EditRecords = () =>{
        localStorage.setItem("AptevoChargebacks",JSON.stringify(aptevoChargeBacks));
        history.push("/AptevoChargebacksEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Aptevo Chargebacks Source Map Monthly</h2>
                {loading ? <Loader /> : null}
                <div>
                {aptevoChargeBacks.length > 0 &&userData.RoleID === 1 && (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns,aptevoChargeBacks,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
             {/* Toaster */}
             {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Aptevo Chargebacks Source.</p> :
                                <Fragment>
                                    {aptevoChargeBacks.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={aptevoChargeBacks} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );


}

export default AptevoChargebacksSourceMapmonthly;